import DateFnsUtils from '@date-io/date-fns';
import {
  AppBar,
  Backdrop,
  Card, CardContent,
  CardHeader,
  Divider, Grid, Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  colors,
  createTheme
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import { makeStyles } from '@material-ui/styles';
import trLocale from 'date-fns/locale/tr';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import Chart from 'react-chartjs-2';
import DisplayField from 'src/components/DisplayField';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import logger from 'src/utils/logger';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    width: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  container: {
    marginTop: theme.spacing(3)
  },
  divider: {
    backgroundColor: colors.grey[300]
  },
  content: {
    marginTop: theme.spacing(3)
  },
  cardsMax: {
    maxHeight: 250,
    minHeight: 250
  },
  TableMax: {
    minHeight: 400,
    maxHeight: 400
  }
}));

const siyah = '#424242';
const materialTheme = createTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});

const localeMap = {
  tr: trLocale
};

const locale = localStorage.getItem('i18nextLng');


function EkGaranti() {
  const classes = useStyles();
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(true);
  const [ekGaranti, setEkGaranti] = useState([]);
  const [Top5Ulke, setTop5Ulke] = useState([]);
  const [Top5Servis, setTop5Servis] = useState([]);
  const [Top5Bolge, setTop5Bolge] = useState([]);
  const [spGrafik, setSPGrafik] = useState([]);
  const [value, setValue] = React.useState('1');
  const [monthlyGrafik, setMonthlyGrafik] = useState([]);
  const [labelsValue, setlabelsValue] = useState([]);
  const [labelsSPValue, setlabelsSPValue] = useState([]);
  const [valuesSP, setvaluesSP] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const changeCiro = React.useCallback(() => {
    if (!Array.isArray(monthlyGrafik)) return;
    var labels = []
    var values = []
    monthlyGrafik.forEach(i => {
      labels.push(i?.SUM_CIRO);
      values.push(i?.Ay);
    })
    setlabelsValue(labels)
  }, [monthlyGrafik]);

  const changeSP = React.useCallback(() => {
    if (!Array.isArray(spGrafik)) return;
    var labelsSP = []
    var valuesSP = []
    spGrafik.forEach(i => {
      labelsSP.push(i.PG);
      valuesSP.push(i.SP);
    })
    setlabelsSPValue(labelsSP)
    setvaluesSP(valuesSP)
  }, [spGrafik]);

  const calculateperformance = React.useCallback((date) => {
    const options = { day: 'numeric', month: 'long' };
    let performancedate = moment(date).format('YYYY-MM-DD')
    axios
      .get(`/GetTeknisyen7GunlukEkGaranti/${SessionUser.TechnicianId}/${performancedate}/${1}`)
      .then(response => {
        var Response = response.data ? response.data : [];
        if (!Response) {
          [0, 1, 2, 3, 4, 5, 6].forEach(i => {
            var temp = moment(performancedate).subtract(i.toString(), 'days').format('YYYY-MM-DD')
            Response.push({
              "SP": 0, "MaxSP": 400, "PG": temp
            })
          })
        } else {
          [0, 1, 2, 3, 4, 5, 6].forEach(i => {
            var temp = moment(performancedate).subtract(i.toString(), 'days').format('YYYY-MM-DD')
            if (Response.filter(i => i.PG === temp).length === 0) {
              Response.push({
                "PG": temp, "SP": 0
              })
            }
          })
        }
        var sortSPGrafik = Response?.sort((itemA, itemB) => new Date(itemA.PG) - new Date(itemB.PG));
        sortSPGrafik.forEach((i, index) => {
          sortSPGrafik[index].PG = new Date(sortSPGrafik[index].PG).toLocaleDateString("tr-TR", options)
        })
        setSPGrafik(sortSPGrafik)
      }).catch(error => {
              logger.error("Hata detayı:", error.message);
      });
  }, [SessionUser.TechnicianId]);

  const calculateperformancemonthly = React.useCallback(() => {
    var numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    let performancedate = moment().format('YYYY-MM-DD')
    axios
      .get(`/GetTeknisyen7GunlukEkGaranti/${SessionUser.TechnicianId}/${performancedate}/${2}`)
      .then(response => {
        var Response = response.data ? response.data : [];
        if (!Response) {
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].forEach(i => {
            var temp = numbers[i]
            Response.push({
              "SUM_CIRO": 0, "Ay": temp
            })
          })
        } else {
          [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].forEach(i => {
            var temp = numbers[i]
            if (Response.filter(i => i.Ay === temp).length === 0) {
              Response.push({
                "SUM_CIRO": 0, "Ay": temp
              })
            }
          })
        }
        var sortCiroMonthly = Response?.sort((itemA, itemB) => new Date(itemA.Ay) - new Date(itemB.Ay));
        setMonthlyGrafik(sortCiroMonthly)
      }).catch(error => {
              logger.error("Hata detayı:", error.message);
      });
  }, [SessionUser.TechnicianId]);


  useEffect(() => {
    if (!monthlyGrafik) {
      return;
    }
    changeCiro()
  }, [monthlyGrafik, changeCiro]);

  useEffect(() => {
    if (!spGrafik) {
      return;
    }
    changeSP()
  }, [spGrafik, changeSP]);


  useEffect(() => {
    let isMounted = true;

    axios
      .get(`/GetTeknisyenGunlukEkGaranti/${SessionUser.TechnicianId}`)
      .then(response => {
        if (isMounted) {
          const Response = response.data[0];
          setEkGaranti(Response);
          setLoading(false);
        }
      }).catch(error => {
        if (isMounted) setLoading(false);
        logger.error("Hata detayı:", error.message);
      });

    return () => {
      isMounted = false;
    };
  }, [SessionUser.TechnicianId]);

  useEffect(() => {
    axios
      .get(`/GetEkGarantiTop5/${SessionUser.TechnicianId}`)
      .then(response => {
        const Response = response.data[0];
        setTop5Ulke(Response?.UlkeSiralamasi);
        setTop5Bolge(Response?.BölgeSiralamasi);
        setTop5Servis(Response?.ServisSiralamasi);
      }).catch(error => {
        logger.error("Hata detayı:", error.message);
      });
  }, [SessionUser.TechnicianId]);

  useEffect(() => {
    var yesterday = moment().add('-1', 'days').format('YYYY-MM-DD')
    calculateperformance(yesterday);
    calculateperformancemonthly();
  }, [SessionUser.TechnicianId, calculateperformance, calculateperformancemonthly]);

  var data = {
    labels: Array.isArray(labelsSPValue) && labelsSPValue.length > 0 ? labelsSPValue.slice(0, 12) : [],
    datasets: [
      {
        type: 'line',
        label: ('Satış Hedefi (TL)'),
        data: Array(7).fill(ekGaranti?.Hedef || 0),
        tension: 0.3,
        backgroundColor: colors.blue[300],
        minBarLength: 10,
      },
      {
        label: ('Gerçek Ciro (TL)'),
        data: Array.isArray(valuesSP) && valuesSP.length > 0 ? valuesSP.slice(0, 12) : [],
        backgroundColor: colors.orange[300],
        minBarLength: 15,
      }
    ]
  };
  const months = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
  var aylikdata = {
    labels: months.slice(0, 12),
    datasets: [
      {
        label: ('Aylık Ciro (TL)'),
        data: Array.isArray(labelsValue) && labelsValue.length > 0 ? labelsValue.slice(0, 12) : [],
        backgroundColor: colors.orange[300],
        minBarLength: 15,
      }
    ]
  }
  var optionsbar = {
    scales: {
      y: {
        min: 0,
        max: (Array.isArray(spGrafik) && spGrafik.length > 0 && typeof spGrafik[0]?.MaxCiro === 'number' && isFinite(spGrafik[0].MaxCiro))
          ? spGrafik[0].MaxCiro
          : 100,
        ticks: {
          // forces step size to be 50 units
          stepSize: 50
        }
      }
    }
  }

  var optionsbar2 = {
    responsive: true,
    maintainAspectRatio: false, // Tab içinde tam sığması için eklenmeli
    scales: {
      y: {
        min: 0,
        // 1. Kontrol: Sayının NaN veya undefined olmasını engelleyin
        max: (ekGaranti && ekGaranti.Hedef)
          ? Math.ceil(ekGaranti.Hedef * 30) // Sayıyı yukarı yuvarlayarak formatlamayı kolaylaştırın
          : 100,
        ticks: {
          stepSize: 100,
          // 2. Kontrol: Formatlamayı manuel yaparak RangeError'ı kesin olarak engelleyin
          callback: function (value) {
            // Sayıyı düz bir string olarak döndürmek veya güvenli bir format kullanmak
            return Number(value).toLocaleString('tr-TR', {
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
            });
          }
        }
      }
    }
  };

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
    calculateperformance(e);
  };

  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-1, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const StartDate = moment()
    .startOf('day')
    .add(-1, 'days')
    .add(12, 'hours')
    .format('YYYY-MM-DD');
  const minDate = moment()
    .startOf('day')
    .add(-45, 'days')
    .add(0, 'hours')
    .format('YYYY-MM-DD');




  return (

    <Card>
      <CardHeader title="Ek-Garanti"
        subheader="(Bir önceki gün yapılan toplam satış ve tutar adetidir.)" />
      <Divider />
      {
        Loading ?
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Grid container spacing={1}>
        <Grid item xs={6} sm={6} lg={6}>
          <Card className={classes.cardsMax}>
            <CardHeader title="Günlük Değerler" />
            <Divider />
            <CardContent>
              <DisplayField
                label={('Satış Performansı')}
                value={
                  ekGaranti?.Ciro ? ekGaranti?.Ciro + ' TL' : '0 TL'
                }
              />
              <DisplayField
                label={('Satış Adeti')}
                value={ekGaranti?.Adet ? ekGaranti?.Adet : '0'}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={6} lg={6}>
          <Card className={classes.cardsMax}>
            <CardHeader title="Günlük Sıralama" />
            <Divider />
            <CardContent>
              <DisplayField
                label={('Servis Sıralaması')}
                value={ekGaranti ? ekGaranti?.ServisSiralamasi + '. / ' + ekGaranti?.ServisTeknisyenleri : "-"}
              />
              <DisplayField
                label={('Bölge Sıralaması')}
                value={ekGaranti ? ekGaranti?.BolgeSiralamasi + '. / ' + ekGaranti?.BölgeTeknisyenleri : "-"}
              />
              <DisplayField
                label={('Türkiye Sıralaması')}
                value={ekGaranti ? ekGaranti?.UlkeSiralamasi + '. / ' + ekGaranti?.UlkeTeknisyenleri : "-"}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Card>
            <Grid container spacing={1}>
              <div className={classes.root}>
                <TabContext value={value}>
                  <AppBar position="static" color="default">
                    <TabList onChange={handleChange} aria-label="simple tabs example">
                      <Tab label=" Günlük Performans" value="1" />
                      <Tab label=" Aylık Performans" value="2" />
                    </TabList>
                  </AppBar>
                  <TabPanel value="1">
                    <Grid item xs={12} sm={12} lg={12} alignItems='flex-end' >
                      <ThemeProvider theme={materialTheme} >
                        <MuiPickersUtilsProvider
                          utils={DateFnsUtils}
                          locale={localeMap[locale]}
                        >
                          <KeyboardDatePicker
                            color="primary"
                            margin="normal"
                            inputVariant="outlined"
                            id="BaslangicTarihi"
                            size="small"
                            label={('Başlangıç Tarihi')}
                            invalidDateMessage={('hatali_tarih')}
                            format="dd.MM.yyyy"
                            fullWidth
                            variant="outlined"
                            value={StartDateSearch}
                            maxDate={StartDate}
                            minDate={minDate}
                            onChange={e => handleChangeStartDateSearch(e)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </ThemeProvider>
                    </Grid>
                    <Divider />
                    <Chart type={'bar'} options={optionsbar} data={data} />
                  </TabPanel>
                  <TabPanel value="2">
                    <Chart type={'bar'} options={optionsbar2} data={aylikdata} />
                  </TabPanel>
                </TabContext>
              </div>
            </Grid>
          </Card>
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Card>
            <CardHeader title="Liderler Tablosu" />
            <CardContent className={classes}>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="left">{('Servis Sıralaması')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[0, 1, 2, 3, 4].map(row => (
                      <TableRow key={row} >
                        <TableCell align="left">{Top5Servis[row] ? Top5Servis[row].ServisSiralamasi : ''}</TableCell>
                        <TableCell align="left">{Top5Servis[row] ? Top5Servis[row].AdSoyad : ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="left">{('Bölge Sıralaması')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[0, 1, 2, 3, 4].map(row => (
                      <TableRow key={row} >
                        <TableCell align="left">{Top5Bolge[row] ? Top5Bolge[row].BolgeSiralamasi : ''}</TableCell>
                        <TableCell align="left">{Top5Bolge[row] ? Top5Bolge[row].AdSoyad : ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table" size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell align="left">{('Türkiye Sıralaması')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {[0, 1, 2, 3, 4].map(row => (
                      <TableRow key={row} >
                        <TableCell align="left">{Top5Ulke[row] ? Top5Ulke[row].UlkeSiralamasi : ''}</TableCell>
                        <TableCell align="left">{Top5Ulke[row] ? Top5Ulke[row].AdSoyad : ''}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Card>
  );
}

export default EkGaranti;